module.exports = __webpack_public_path__ + "img/level_02.f1d71fd9.svg";